import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { t, T } from 'helpers/i18n';
import { Search, SortType } from 'helpers/FuzzySearch';
import { narutalSort } from 'helpers/Utils';
import { Filter, SearchInput } from 'components';
import { Icon, Loading } from 'elements';
import { AddButton } from 'Styles';
import theme from 'Theme';
import './Table.css';
class Table extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            items: this.props.items,
            sortType: undefined,
            sortHeader: undefined,
            searchTerm: undefined,
            filterSelected: 0,
            isMobile: false
        };
        this.onHandleResize = () => {
            const isMobile = window.matchMedia(`(max-width: ${theme.common.devices.desktopWidth - 1})`).matches;
            this.setState({ isMobile });
        };
        this.handleFilter = (value) => {
            this.setState({ filterSelected: value });
        };
        this.handleSearch = (searchTerm) => {
            this.setState({ searchTerm: searchTerm || undefined });
        };
        this.handleSelectHead = (head) => {
            let sort = undefined;
            if (head !== this.state.sortHeader)
                sort = SortType.Asc;
            if (head === this.state.sortHeader && this.state.sortType !== SortType.Desc)
                sort = SortType.Desc;
            this.setState({ sortType: sort, sortHeader: sort ? head : undefined });
        };
        this.filteredItems = () => {
            const { items, filterSelected, sortType, sortHeader, searchTerm } = this.state;
            const { filters } = this.props;
            const header = this.props.header || Object.keys(this.props.items[0]);
            let filteredItems = items;
            if (filters) {
                filteredItems = filteredItems.filter(filters[filterSelected].filter);
            }
            if (sortHeader) {
                filteredItems = narutalSort(filteredItems, sortHeader, sortType === SortType.Desc);
            }
            if (searchTerm) {
                filteredItems = Search(searchTerm, filteredItems, header);
            }
            return filteredItems;
        };
        this.translated = (item) => {
            // console.log('items', item)
            // console.log('t(String(item))', t(String(item)))
            // console.log('t(String(item)).includes', t(String(item)).includes('@@'))
            if (item && !t(String(item)).includes('@@')) {
                // console.log('traducido', t(String(item)))
                return t(String(item));
            }
            return item;
        };
        this.reduce = (item) => {
            // console.log(`type of item ${item}`, typeof item)
            return item;
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.items !== this.state.items)
            this.setState({ items: nextProps.items });
    }
    componentDidMount() {
        window.addEventListener('resize', this.onHandleResize);
        this.onHandleResize();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onHandleResize);
    }
    render() {
        const { keyExtractor, onSelectItem, onCreate, filters, search, loading, selected } = this.props;
        const { sortType, sortHeader, filterSelected, isMobile } = this.state;
        const items = this.filteredItems();
        // console.log('Table - render - items: ', items)
        const header = this.props.header || Object.keys(this.props.items[0]);
        if (loading)
            return React.createElement(Loading, null);
        const handle = this.props.handleSearch ? this.props.handleSearch : this.handleSearch;
        const numero = 'numero';
        return (React.createElement(Wrapper, null,
            React.createElement(Bar, null,
                search && React.createElement(StyledSearchInput, { onChange: handle }),
                filters && (React.createElement(Filter, { filters: filters, onSelect: this.handleFilter, selectedFilter: filterSelected }))),
            items.length === 0 &&
                React.createElement("div", null, T('noDatosMostrar')),
            items.length > 0 && !isMobile &&
                React.createElement("div", { style: {
                        maxHeight: (Theme.common.devices.desktopHeight - 3.6 * Theme.common.size.bar) + 'px',
                        overflowY: 'scroll',
                        overflowX: 'hidden',
                    } },
                    React.createElement(StyledTable, { onCreate: onCreate },
                        React.createElement("thead", null,
                            React.createElement("tr", null, header.map((head, index) => (React.createElement(Th, { key: head, onClick: () => this.handleSelectHead(head) },
                                T(head),
                                React.createElement(Sort, null, head === sortHeader &&
                                    (sortType === SortType.Asc ? React.createElement(SortAsc, null) : React.createElement(SortDesc, null)))))))),
                        React.createElement("tbody", null, items.map((item, iter) => (React.createElement(Tr, { style: {
                                backgroundColor: item[numero] === selected ? Theme.color.primary : undefined
                            }, key: keyExtractor(item), onClick: onSelectItem && (() => onSelectItem(item)) }, header.map((head, index) => React.createElement(Td, { key: index }, item[head])))))))),
            isMobile &&
                React.createElement("div", { style: {
                        /*backgroundColor: 'yellow',*/
                        marginBottom: Theme.common.size.bar * 2 + 'px'
                    } }, items.map((item, index) => {
                    return (React.createElement("div", { onClick: onSelectItem && (() => onSelectItem(item)), key: keyExtractor(item) },
                        React.createElement(Row, null, header.map((head, indice) => (React.createElement(Column, { key: indice },
                            React.createElement("span", { style: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                }, onClick: onSelectItem && (() => onSelectItem(item)), key: head },
                                React.createElement("span", { style: {
                                        fontWeight: 'bold',
                                        maxWidth: '30%',
                                        minWidth: '125px',
                                        display: 'inlineBlock',
                                        /*backgroundColor: '#f489f0',*/
                                        flexGrow: 0,
                                        flexShrink: 0
                                    }, className: "header" },
                                    t(head),
                                    ":"),
                                React.createElement("span", { style: {
                                        flexGrow: 0,
                                        flexShrink: 0,
                                        textTransform: 'none',
                                    } }, item[head]))))))));
                })),
            onCreate && (React.createElement(AddButton, { primary: true, onClick: onCreate }, T('add')))));
    }
}
Table.defaultProps = {
    search: true
};
export default Table;
const Row = ({ header = false, children }) => {
    const headerStyle = header ? {
        boxShadow: `0 1px 2px 0 ${theme.color.hairline}`,
    } : undefined;
    return (React.createElement("div", { style: Object.assign({ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', width: '100%', padding: '12px', borderBottom: `1px solid ${theme.color.hairline}`, boxSizing: 'border-box' }, headerStyle) },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
            } }, children)));
};
const Column = ({ children }) => (React.createElement("div", null, children));
const Wrapper = cxs('div')(({ width }) => ({
    minHeight: '200px',
    width: width ? width : '100%'
}));
const Bar = cxs('div')({
    display: 'flex',
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
});
const StyledSearchInput = cxs(SearchInput)({
    flex: 1,
});
const StyledTable = cxs('table')(({ onCreate }) => (Object.assign(Object.assign({ width: '100%' }, onCreate ? { marginBottom: Theme.size.bar } : undefined), { ' tr:nth-child(even)': {
        backgroundColor: Theme.color.rowBackground
    } })));
const StyledDiv = cxs('div')({
    ' :hover div': {
        backgroundColor: Theme.color.rowBackground
    },
    ' :nth-child(odd)': {
        backgroundColor: Theme.color.hairline
    },
});
StyledTable.propTypes = {
    onCreate: PropTypes.func
};
const Th = cxs('th')({
    padding: Theme.size.space[1],
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    cursor: 'pointer'
});
const Sort = cxs('span')({
    padding: `0 ${Theme.size.space[1]}`,
    position: 'relative',
    '> icon': {
        left: '2px',
        position: 'absolute',
        lineHeight: 1.25,
        padding: 0
    }
});
const sortIcon = props => (React.createElement(Icon, Object.assign({}, props, { name: "back", size: parseInt(Theme.fontSize.small, 0) })));
const SortAsc = cxs(sortIcon)({
    transform: 'rotate(90deg)'
});
const SortDesc = cxs(sortIcon)({
    transform: 'rotate(-90deg)'
});
const Tr = cxs('tr')(({ onClick }) => (Object.assign({}, onClick ? { cursor: 'pointer' } : undefined)));
const Td = cxs('td')({
    padding: Theme.size.space[1],
    textAlign: 'center',
    ':last-child': {
        /*textAlign: 'right',*/
        whiteSpace: 'nowrap'
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/Table.tsx
// module id = 549
// module chunks = 0